import { render, staticRenderFns } from "./LiveBigBannerPlayerCell.vue?vue&type=template&id=116e2991&scoped=true"
import script from "./LiveBigBannerPlayerCell.vue?vue&type=script&setup=true&lang=js"
export * from "./LiveBigBannerPlayerCell.vue?vue&type=script&setup=true&lang=js"
import style0 from "./LiveBigBannerPlayerCell.vue?vue&type=style&index=0&id=116e2991&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116e2991",
  null
  
)

export default component.exports